
export class AlertMessage {

    id: string;
    message: string;
    type: string;

    constructor(id: string, message: string, type: string) {
        this.id = id;
        this.message = message;
        this.type = type
    }

}

